export default {
    url: '/by_month',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 800,
        title: 'by Month',
    },
    controller: [
        '$scope',
        '$location',
        'life_time_api',
        'chartFilters',
        function ($scope, $location, life_time_api, chartFilters) {
            $scope.data = {};
            $scope.ranges = {};
            $scope.gradient_colors = [
                '#ecf8ff',
                '#E6F5FF',
                '#DBF0FF',
                '#D1ECFF',
                '#C7E8FF',
                '#BDE4FF',
                '#B3E0FF',
                '#A8DCFF',
                '#9ED8FF',
                '#94D4FF',
                '#8AD0FF',
                '#80CCFF',
                '#78c4ff',
            ];
            $scope.update_ltv_table = function (model) {
                life_time_api.by_month(model).then(function (resp) {
                    $scope.data = resp;
                    $scope.calculate_ranges();
                });
            };
            $scope.calculate_ranges = function () {
                var data_keys = Object.keys($scope.data[0]);
                for (var key_i = 0; key_i < data_keys.length; key_i++) {
                    var values_list = [];
                    for (var i = 0; i < $scope.data.length; i++) {
                        values_list.push($scope.data[i][data_keys[key_i]]);
                    }
                    $scope.ranges[data_keys[key_i]] = {
                        min: Math.min.apply(Math, values_list),
                        max: Math.max.apply(Math, values_list),
                    };
                }
            };
            $scope.apply_color = function (value, key) {
                if (value != -1) {
                    var position =
                        (value - $scope.ranges[key]['min']) /
                        ($scope.ranges[key]['max'] - $scope.ranges[key]['min']);
                    return $scope.gradient_colors[Math.floor(position * ($scope.gradient_colors.length - 1))];
                }
            };
            $scope.apply = function (value) {
                if (value == -1) {
                    return '-';
                } else {
                    return value;
                }
            };
            chartFilters.onChangeChartParams('update_ltv_table', $scope.update_ltv_table);
            $scope.update_ltv_table(chartFilters.get_chart_filters());
        },
    ],
};
